import colors from 'vuetify/lib/util/colors'

const ColorsMixin = {
  data () {
    return {
      colors: [
        colors.orange.lighten3,
        colors.blue.lighten2,
        colors.red.lighten3,
        colors.lightBlue.lighten3,
        colors.green.lighten3,
        colors.yellow.lighten2,
        colors.purple.lighten3,
        colors.pink.lighten3,
        colors.indigo.lighten3,
        colors.cyan.lighten3,
        colors.lime.lighten3,
        colors.teal.lighten3,
        colors.deepPurple.lighten2,
        colors.amber.lighten2,
        colors.brown.lighten3,
        colors.deepOrange.lighten3,
        colors.blueGrey.lighten3
      ],
      darkColors: [
        'primary',
        colors.orange.darken3,
        colors.green.darken3,
        colors.red.darken3,
        colors.teal.darken1,
        colors.purple.darken3,
        colors.yellow.darken2,
        colors.lightBlue.darken1,
        colors.lime.darken2,
        colors.deepOrange.darken2,
        colors.lightGreen.darken2,
        colors.indigo.darken2,
        colors.purple.darken1
      ]
    }
  },
  methods: {
    getDarkColor (index) {
      return this.darkColors[index] || 'primary'
    }
  }
}

export default ColorsMixin
